export default "__VITE_ASSET__eQhUvdp1__"